import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PassCheckType, SetPasswordParams } from 'mbs-ui-shared@models/password';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  private http = inject(HttpClient);

  private readonly controllerPath = 'api/password';

  public checkPasswordStrength(password: string): Observable<PassCheckType> {
    return this.http.post<PassCheckType>(`${this.controllerPath}/policy/check`, { password });
  }

  public getPasswordRules(): Observable<string[]> {
    return this.http.get<string[]>(`${this.controllerPath}/help`);
  }

  public generatePassword(): Observable<string> {
    return this.http.get<string>(`${this.controllerPath}/generate`);
  }

  public setNewPassword(params: SetPasswordParams): Observable<null> {
    return this.http.post<null>(`${this.controllerPath}/forgot/set`, params);
  }
}
